module.exports = __webpack_public_path__ + "static/media/Cute Little Devil.5e47dfba.jpg";